import { useMemo } from 'react';

// material-ui
import { Theme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';

// project imports
// import Search from './Search';
// import Message from './Message';
import Profile from './Profile';
// import Localization from './Localization';
import ThemeModeToggle from './ThemeModeToggle';
// import Notification from './Notification';
// import FullScreen from './FullScreen';
// import Customization from './Customization';
import CompanySelector from './CompanySelector';
import MobileSection from './MobileSection';
// import MegaMenuSection from './MegaMenuSection';

import useConfig from 'hooks/useConfig';
import { MenuOrientation } from 'config';
import DrawerHeader from 'layout/Dashboard/Drawer/DrawerHeader';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const { menuOrientation } = useConfig();

  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

  // const localization = useMemo(() => <Localization />, []);
  const themeModeToggle = useMemo(() => <ThemeModeToggle />, []);

  // const megaMenu = useMemo(() => <MegaMenuSection />, []);

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && <DrawerHeader open={true} />}
      {!downLG && <CompanySelector />}
      {/*{!downLG && <Search />}*/}
      {/*{!downLG && megaMenu}*/}
      {!downLG && themeModeToggle}
      {downLG && <Box sx={{ width: '100%', ml: 1 }} />}

      {/*<Notification />*/}
      {/*<Message />*/}
      {/*{!downLG && <FullScreen />}*/}
      {/*<Customization />*/}
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
}
